/* site-effects.js - builds the falling / floating decorations set up in the Site effects section */
(function () {
  var KEY = 'fx_seen_';
  var layers = [];
  var token = 0;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var SHAPES = {
    leaves: 'M20 3C10 3 3.5 8.5 3.5 16c0 2.3.9 4.2 2.2 4.8.2-3.3 2-6.5 6.3-8.8-3.2 3.2-4.3 5.5-4.5 8.8 8.2-.3 12.5-6.8 12.5-17.8z',
    stars: 'M12 2l3 7 7.6.7-5.7 5 1.7 7.5L12 18.2 5.4 22.2l1.7-7.5-5.7-5L9 9z',
    sparkles: 'M12 0c.9 7 5 11.1 12 12-7 .9-11.1 5-12 12-.9-7-5-11.1-12-12 7-.9 11.1-5 12-12z',
    hearts: 'M12 21.5S3 16 3 9.6A4.9 4.9 0 0 1 12 7a4.9 4.9 0 0 1 9 2.6C21 16 12 21.5 12 21.5z'
  };
  var FERN = [
    'M12 21C8 21 5 19 3 16C7 16 10 17.5 12 21z',
    'M12 17C8.5 17 6 15 4.5 12C8 12 10.5 13.5 12 17z',
    'M12 13C9.5 13 7.5 11.5 6.5 9C9 9 11 10.2 12 13z',
    'M12 9.5C10.5 9.5 9 8.5 8.4 6.5C10 6.6 11.3 7.5 12 9.5z',
    'M12 21C16 21 19 19 21 16C17 16 14 17.5 12 21z',
    'M12 17C15.5 17 18 15 19.5 12C16 12 13.5 13.5 12 17z',
    'M12 13C14.5 13 16.5 11.5 17.5 9C15 9 13 10.2 12 13z',
    'M12 9.5C13.5 9.5 15 8.5 15.6 6.5C14 6.6 12.7 7.5 12 9.5z',
    'M12 6.5C11 6 10.6 4.5 11 3C12 4 12.2 5.3 12 6.5z'
  ].map(function (d) { return `<path d='${d}'/>`; }).join('');
  var NATURAL = {
    snow: ['#cfe6ff', '#ffffff', '#a8cdf3'],
    snowflakes: ['#9ec9f5', '#c9e2fb'],
    leaves: ['#2f9e44', '#f08c00', '#c92a2a'],
    ferns: ['#3f8f5b', '#5fae7a', '#2f7d4f'],
    stars: ['#f7c52b', '#fde68a', '#f59e0b'],
    starfish: ['#f6c96b', '#f4b95a', '#f8d98a'],
    sparkles: ['#f7c52b', '#fde68a', '#f59e0b'],
    hearts: ['#ff6b81', '#ff4d6d', '#ffb3c1'],
    bubbles: ['#9ec9f5', '#b8e0f7', '#a5d8ff'],
    flowers: ['#ff8fab', '#ffd166', '#c77dff'],
    emoji: ['#111111'],
    confetti: ['#ef4444', '#f59e0b', '#22c55e', '#3b82f6', '#a855f7'],
    ribbons: ['#ef4444', '#f59e0b', '#3b82f6', '#ec4899'],
    badge: ['#e11d48', '#f59e0b', '#111111'],
    coupon: ['#e11d48', '#0f766e', '#7c3aed'],
    percent: ['#e11d48', '#f59e0b', '#16a34a']
  };
  var DEFAULTS = {
    emoji: ['🔥', '🎉', '💖'],
    badge: ['SALE', 'HOT', 'NEW'],
    coupon: ['SAVE10', 'DEAL20', 'FREESHIP'],
    percent: ['10% OFF', '20% OFF', '50% OFF']
  };
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function pick(a) { return a[Math.floor(Math.random() * a.length)]; }
  function num(el, k, d) { var v = parseFloat(el.getAttribute('data-' + k)); return isNaN(v) ? d : v; }
  function split(s) { return (s || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean); }
  function isDate(s) { return s.length === 10 && s.charAt(4) === '-' && s.charAt(7) === '-'; }
  function today() {
    var d = new Date();
    function p(n) { return (n < 10 ? '0' : '') + n; }
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
  }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }
  function svg(type, size, color) {
    var inner;
    if (type === 'ferns') {
      inner = `<path d='M12 23V4' stroke='${color}' stroke-width='1.1' fill='none' stroke-linecap='round'/>` + FERN;
    } else if (type === 'starfish') {
      inner = `<path d='M12 3l2.4 6.3L21 10l-5 4.4 1.6 6.6L12 17.4 6.4 21 8 14.4 3 10l6.6-.7z' stroke='${color}' stroke-width='2.6' stroke-linejoin='round'/><circle cx='12' cy='11.6' r='1.3' fill='rgba(255,255,255,.6)'/>`;
    } else if (type === 'flowers') {
      inner = [0, 72, 144, 216, 288].map(function (a) { return `<ellipse cx='12' cy='6.2' rx='3' ry='4.6' transform='rotate(${a} 12 12)'/>`; }).join('') + `<circle cx='12' cy='12' r='2.4' fill='#fff7c2'/>`;
    } else {
      inner = `<path d='${SHAPES[type]}'/>`;
    }
    return `<svg viewBox='0 0 24 24' width='${size}' height='${size}' fill='${color}' aria-hidden='true'>${inner}</svg>`;
  }
  function glyph(text, size, color) {
    var g = document.createElement('span');
    g.className = 'fx-glyph';
    g.style.fontSize = size + 'px';
    g.style.color = color;
    g.textContent = text;
    return g;
  }
  function eligible(el, pageType) {
    if (el.getAttribute('data-once') === 'true' && !designMode()) {
      try { if (sessionStorage.getItem(KEY + el.getAttribute('data-id'))) return false; } catch (e) {}
    }
    var s = el.getAttribute('data-start') || '';
    var e = el.getAttribute('data-end') || '';
    var t = today();
    if (isDate(s) && t < s) return false;
    if (isDate(e) && t > e) return false;
    var path = (window.location.pathname || '/').toLowerCase();
    var ex = split(el.getAttribute('data-exclude')).map(function (x) { return x.toLowerCase(); });
    if (ex.some(function (x) { return path.indexOf(x) > -1; })) return false;
    if (el.getAttribute('data-all') === 'true') return true;
    var types = (el.getAttribute('data-types') || '').split(',');
    if (types.indexOf(pageType) > -1) return true;
    var urls = split(el.getAttribute('data-urls')).map(function (x) { return x.toLowerCase(); });
    return urls.some(function (x) { return x === '/' ? path === '/' : path.indexOf(x) > -1; });
  }
  function visual(type, size, color, texts, tc) {
    var v;
    switch (type) {
      case 'snow':
        v = document.createElement('span');
        v.className = 'fx-dot';
        v.style.cssText = 'width:' + size + 'px;height:' + size + 'px;background:' + color;
        return v;
      case 'snowflakes':
        return glyph('\u2744\ufe0e', size, color);
      case 'leaves':
      case 'ferns':
      case 'stars':
      case 'starfish':
      case 'sparkles':
      case 'hearts':
      case 'flowers':
        v = document.createElement('span');
        v.className = 'fx-svg';
        v.innerHTML = svg(type, size, color);
        return v;
      case 'bubbles':
        v = document.createElement('span');
        v.className = 'fx-bubble';
        v.style.cssText = 'width:' + size + 'px;height:' + size + 'px;border-color:' + color;
        return v;
      case 'emoji':
        return glyph(pick(texts), size, color);
      case 'confetti':
        v = document.createElement('span');
        v.className = 'fx-conf';
        v.style.cssText = 'width:' + (size * 0.5) + 'px;height:' + size + 'px;background:' + color;
        return v;
      case 'ribbons':
        v = document.createElement('span');
        v.className = 'fx-rib';
        v.style.cssText = 'width:' + (size * 0.3) + 'px;height:' + (size * 2.4) + 'px;background:' + color;
        return v;
      default:
        v = document.createElement('span');
        v.className = 'fx-chip fx-chip--' + type;
        v.textContent = pick(texts);
        if (type === 'percent') {
          v.style.cssText = 'width:' + (size * 1.5) + 'px;height:' + (size * 1.5) + 'px;font-size:' + (size * 0.34) + 'px;background:' + color + ';color:' + tc;
        } else if (type === 'coupon') {
          v.style.cssText = 'height:' + size + 'px;padding:0 ' + (size * 0.4) + 'px;font-size:' + (size * 0.4) + 'px;color:' + color;
        } else {
          v.style.cssText = 'height:' + size + 'px;padding:0 ' + (size * 0.45) + 'px;font-size:' + (size * 0.42) + 'px;background:' + color + ';color:' + tc;
        }
        return v;
    }
  }
  function make(cfg) {
    var type = pick(cfg.types);
    var isMain = type === cfg.main;
    var colors = (isMain && !cfg.naturalMain) ? cfg.colors : (NATURAL[type] || cfg.colors);
    var texts = (isMain && cfg.texts.length) ? cfg.texts : (DEFAULTS[type] || ['*']);
    var size = rnd(cfg.smin, Math.max(cfg.smin, cfg.smax));
    var dur = rnd(cfg.dmin, Math.max(cfg.dmin, cfg.dmax));
    var op = rnd(cfg.omin, Math.max(cfg.omin, cfg.omax)) / 100;
    var calm = cfg.calm;
    var p = document.createElement('span');
    p.className = 'fx-p fx-p--' + cfg.motion;
    p.style.left = rnd(0, 100) + '%';
    p.style.setProperty('--dur', dur + 's');
    p.style.setProperty('--wind', (cfg.wind * rnd(0.6, 1.2)) + 'px');
    if (cfg.motion === 'float') {
      p.style.top = rnd(0, 100) + '%';
      p.style.animationDelay = rnd(0, dur) + 's';
    } else {
      p.style.animationDelay = (-rnd(0, dur)) + 's';
    }
    var m = document.createElement('span');
    m.className = 'fx-m' + (cfg.sway > 0 ? '' : ' fx-m--still');
    m.style.setProperty('--sway', (cfg.sway * rnd(0.5, 1)) + 'px');
    m.style.setProperty('--sway-dur', (rnd(4, 9) / calm) + 's');
    var i = document.createElement('span');
    i.className = 'fx-i';
    i.style.opacity = op;
    if (cfg.blur > 0) i.style.filter = 'blur(' + rnd(0, cfg.blur) + 'px)';
    if (cfg.twinkle) {
      i.style.opacity = '';
      i.style.setProperty('--o-min', op * 0.2);
      i.style.setProperty('--o-max', op);
      i.style.animation = 'fx-twinkle ' + (rnd(2, 4.5) / calm) + 's ease-in-out infinite';
      i.style.animationDelay = (-rnd(0, 4)) + 's';
    } else if (cfg.flip) {
      i.style.setProperty('--r0', rnd(0, 360) + 'deg');
      i.style.animation = 'fx-flip ' + (rnd(4, 8) / calm) + 's linear infinite';
      i.style.animationDelay = (-rnd(0, 8)) + 's';
    } else if (cfg.spin > 0) {
      var full = cfg.spin >= 360;
      var deg = full ? Math.round(cfg.spin / 360) * 360 : cfg.spin;
      i.style.setProperty('--spin', (deg * (Math.random() < 0.5 ? -1 : 1)) + 'deg');
      i.style.animation = 'fx-spin ' + (rnd(8, 16) / calm) + 's ' + (full ? 'linear' : 'ease-in-out') + ' infinite ' + (full ? 'normal' : 'alternate');
      i.style.animationDelay = (-rnd(0, 12)) + 's';
    }
    i.appendChild(visual(type, size, pick(colors), texts, cfg.tc));
    m.appendChild(i);
    p.appendChild(m);
    return p;
  }
  function clear() {
    layers.forEach(function (l) { if (l.parentNode) l.parentNode.removeChild(l); });
    layers = [];
  }
  function start(el, myToken) {
    var mobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
    if (mobile && el.getAttribute('data-mobile') !== 'true') return;
    var main = el.getAttribute('data-type') || 'snow';
    var types = [main];
    split(el.getAttribute('data-mix')).forEach(function (t) { if (types.indexOf(t) < 0) types.push(t); });
    var colors = [el.getAttribute('data-c1'), el.getAttribute('data-c2'), el.getAttribute('data-c3')].filter(Boolean);
    if (!colors.length) colors = ['#ffffff'];
    var cfg = {
      main: main,
      types: types,
      naturalMain: el.getAttribute('data-natural-main') === 'true',
      motion: el.getAttribute('data-motion') || 'fall',
      smin: num(el, 'smin', 8),
      smax: num(el, 'smax', 20),
      dmin: num(el, 'dmin', 14),
      dmax: num(el, 'dmax', 28),
      omin: num(el, 'omin', 50),
      omax: num(el, 'omax', 100),
      sway: num(el, 'sway', 40),
      wind: num(el, 'wind', 0),
      spin: num(el, 'spin', 0),
      blur: num(el, 'blur', 0),
      calm: Math.max(0.1, num(el, 'calm', 60) / 100),
      flip: el.getAttribute('data-flip') === 'true',
      twinkle: el.getAttribute('data-twinkle') === 'true',
      colors: colors,
      texts: split(el.getAttribute('data-texts')),
      tc: el.getAttribute('data-tc') || '#ffffff'
    };
    var count = Math.max(1, Math.min(100, Math.round(mobile ? num(el, 'count-mobile', 6) : num(el, 'count', 12))));
    var id = el.getAttribute('data-id');
    if (el.getAttribute('data-once') === 'true' && !designMode()) {
      try { sessionStorage.setItem(KEY + id, '1'); } catch (e) {}
    }
    function mount() {
      if (myToken !== token) return;
      var layer = document.createElement('div');
      layer.className = 'fx-layer fx-layer--' + (el.getAttribute('data-layer') || 'front');
      layer.setAttribute('aria-hidden', 'true');
      for (var n = 0; n < count; n++) layer.appendChild(make(cfg));
      document.body.appendChild(layer);
      layers.push(layer);
      var stop = num(el, 'stop', 0);
      if (stop > 0) {
        setTimeout(function () {
          layer.classList.add('is-fading');
          setTimeout(function () { if (layer.parentNode) layer.parentNode.removeChild(layer); }, 1400);
        }, stop * 1000);
      }
    }
    var delay = num(el, 'delay', 0);
    if (delay > 0) setTimeout(mount, delay * 1000); else mount();
  }
  function run() {
    clear();
    token++;
    if (reduce) return;
    var root = document.getElementById('site-effects');
    if (!root) return;
    var pageType = root.getAttribute('data-page-type') || '';
    var myToken = token;
    [].slice.call(root.querySelectorAll('[data-fx]')).forEach(function (el) {
      if (eligible(el, pageType)) start(el, myToken);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:unload', function () { token++; clear(); });
})();
